<template>
  <div v-if="inProcess" class="full-screen flex flex-center">
    <vue-loading type="spiningDubbles" color="#efad4c" :size="{ width: '25px', height: '25px' }" />
  </div>
  <cupertino-alert-dialog v-else title="連携解除の最終確認" :close="onClickOutSide">
    <template v-slot:content>
      <div class="px-1 py-1">
        この原稿をNolaノベル上のエピソードと連携解除してよろしいですか？ <br />
        なお、連携解除後もNola、Nolaノベルともにデータが削除されることはありません。
      </div>
    </template>
    <template v-slot:actions>
      <div class="flex flex-row flex-center flex-spacearound">
        <div
          class="w-full border-right-1 flex flex-center pointer py-1 hover left-bottom-radius-10"
          @click="onCancelClick"
        >
          <span>キャンセル</span>
        </div>
        <div class="w-full flex flex-center pointer py-1 hover right-bottom-radius-10" @click="onDelinkClick">
          <span class="color-red">連携解除する</span>
        </div>
      </div>
    </template>
  </cupertino-alert-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import CupertinoAlertDialog from "@/components/ui/dialogs/CupertinoAlertDialog.vue";
import { VueLoading } from "vue-loading-template";
import { EpisodeFromNolaNovel } from "@/lib/models";

interface Data {
  inProcess: boolean;
}

interface Methods {
  onClickOutSide: () => void;
  onCancelClick: () => void;
  onDelinkClick: () => void;
}

interface Computed {
  episode: EpisodeFromNolaNovel;
}

interface Props {
  novelId: string;
  manuscriptId: string;
  episodeId: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { CupertinoAlertDialog, VueLoading },

  data() {
    return {
      inProcess: false,
    };
  },

  methods: {
    onClickOutSide() {
      this.$close(false);
    },
    onCancelClick() {
      this.$close(false);
    },
    async onDelinkClick() {
      const { dispatch } = this.$store;
      const { novelId, manuscriptId, episodeId, episode } = this;
      this.inProcess = true;
      try {
        await dispatch("nolaNovelModule/deleteEpisodeLink", {
          novelId,
          manuscriptIds: [manuscriptId],
          episodes: [episode ?? episodeId],
        });
      } catch (e) {
        this.inProcess = false;
        this.$close(false);
        return;
      }

      this.inProcess = false;
      this.$close(true);
    },
  },

  computed: {
    episode() {
      const { episodeId } = this;
      const { getters } = this.$store;

      return getters["nolaNovelModule/episode"](episodeId);
    },
  },

  props: {
    novelId: String,
    manuscriptId: String,
    episodeId: String,
  },
});

export type EpisodeDelinkConfirmProps = Props;
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

// container

.w-full {
  width: 100%;
}

.full-screen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9000;
  background-color: var(--color-overlay);
}

// button

.pointer {
  cursor: pointer;
}

.hover {
  position: relative;
  @include hover-overlay;
}

// flex

.flex {
  display: flex;
}

.flex-row {
  flex-direction: row;
}

.flex-center {
  align-items: center;
  justify-content: center;
}

.flex-spacearound {
  justify-content: space-around;
}

// padding, margin

.px-1 {
  padding-right: 1rem;
  padding-left: 1rem;
}

.py-1 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

// border

.border-right-1 {
  border-right: solid 1px var(--color-border);
}

.left-bottom-radius-10 {
  border-radius: 0px 0px 0px var(--radius-sm);
}

.right-bottom-radius-10 {
  border-radius: 0px 0px var(--radius-sm) 0px;
}

// color

.color-red {
  color: var(--color-warning);
}
</style>
